var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg404(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "235px",
    height: "103px",
    viewBox: "0 0 235 103",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "404") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "-377.210115%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB46D",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8738",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M356.856,818.704 L356.856,833.824 L345.768,833.824 L345.768,856 L328.488,856 L328.488,833.824 L289.176,833.824 L289.176,818.704 L299.832,765.712 L316.392,765.712 L306.744,818.704 L328.488,818.704 L328.488,781.552 L345.768,781.552 L345.768,818.704 L356.856,818.704 Z M436.056,810.64 C436.056,827.824086 433.488026,839.895965 428.352,846.856 C423.215974,853.816035 414.072066,857.296 400.92,857.296 C392.663959,857.296 386.208023,856.28801 381.552,854.272 C376.895977,852.25599 373.368012,849.040022 370.968,844.624 C369.143991,841.167983 367.800004,836.728027 366.936,831.304 C366.101789,826.067008 365.670306,819.465331 365.641541,811.498782 L365.64,810.64 C365.64,793.647915 368.231974,781.672035 373.416,774.712 C378.600026,767.751965 387.767934,764.272 400.92,764.272 C409.176041,764.272 415.607977,765.25599 420.216,767.224 C424.824023,769.19201 428.327988,772.431977 430.728,776.944 C432.552009,780.304017 433.895996,784.671973 434.76,790.048 C435.624004,795.424027 436.056,802.287958 436.056,810.64 Z M418.632,810.64 L418.627834,809.341911 C418.551454,797.585775 417.424853,789.762546 415.248,785.872 C412.991989,781.83998 408.216036,779.824 400.92,779.824 C393.815964,779.824 389.088012,781.887979 386.736,786.016 C384.383988,790.144021 383.208,798.351939 383.208,810.64 L383.212166,811.927984 C383.288546,823.591488 384.415147,831.322086 386.592,835.12 C388.848011,839.05602 393.623964,841.024 400.92,841.024 C408.024036,841.024 412.751988,838.98402 415.104,834.904 C417.456012,830.82398 418.632,822.73606 418.632,810.64 Z M513.672,818.704 L513.672,833.824 L502.584,833.824 L502.584,856 L485.304,856 L485.304,833.824 L445.992,833.824 L445.992,818.704 L456.648,765.712 L473.208,765.712 L463.56,818.704 L485.304,818.704 L485.304,781.552 L502.584,781.552 L502.584,818.704 L513.672,818.704 Z",
    id: "path-2"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-4.5%",
    y: "-5.4%",
    width: "108.9%",
    height: "121.5%",
    filterUnits: "objectBoundingBox",
    id: "filter-3"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 5,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.75 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Under-Screens",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "P2---Login-Copy",
    transform: "translate(-284.000000, -764.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: 404
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-3)",
    xlinkHref: "#path-2"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    xlinkHref: "#path-2"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-1)",
    xlinkHref: "#path-2"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg404);
export default __webpack_public_path__ + "static/media/404.2d920efddeddcdc9b739a338101871bb.svg";
export { ForwardRef as ReactComponent };